import React, {Component} from 'react'
import Link from 'gatsby-link'
import {Header} from '../components/Header'
import {Footer} from '../components/Footer'
import {FeaturedArtists} from '../components/FeaturedArtists'
import {ArtistGrid} from '../components/ArtistGrid'
import {OverviewBlocks} from '../components/OverviewBlocks'
import {InfoSection} from '../components/InfoSection/'
import {LinkBox} from '../components/LinkBox'
import {Journals} from '../components/Journals'
import {withPrefix} from 'gatsby-link';
import logoSrc from '../../static/logo_color.png'
import './2017-inaugural-season.css'

import en from '../data-en'
import cn from '../data-cn'
import locale from '../locale'
let data = { en, cn };
let localizedData = () => data[locale.getLocale()];
let inaugural_season_page = localizedData().inaugural_season_page;
let enIndex = 1;

class InauguralSeasonPage extends Component {
  render() {

    let featuredArtistSizes = [
      this.props.data.ludovicMorlotImage.sizes,
      this.props.data.yujaWangImage.sizes,
      this.props.data.olgaKernImage.sizes
    ];

    let overviewSizes = [
      this.props.data.trainingResidencyImage.sizes,
      this.props.data.jointRehearsalImage.sizes,
      this.props.data.carnegieDebutImage.sizes,
      this.props.data.concertTourImage.sizes
    ];

    let teachingArtistSizes = [
      this.props.data.jindongCaiImage.sizes,
      this.props.data.frankHuangImage.sizes,
      this.props.data.qingLiImage.sizes,
      this.props.data.jayLiuImage.sizes,
      this.props.data.qiangTuImage.sizes,
      this.props.data.daxunZhangImage.sizes,
      this.props.data.sibeiWengImage.sizes,
      this.props.data.yaoguangZhaiImage.sizes,
      this.props.data.liangWangImage.sizes,
      this.props.data.feiXieImage.sizes,
      this.props.data.xiaomingHanImage.sizes,
      this.props.data.guangChenImage.sizes,
      this.props.data.weiZhuImage.sizes,
      this.props.data.haiyuWangImage.sizes,
      this.props.data.gertMortensenImage.sizes,
      this.props.data.jieyinWuImage.sizes,
    ];

    return (
      <div>
        <Header src={logoSrc} data={localizedData().header}></Header>

        <div className="margin-large">

          <InfoSection
            title = {inaugural_season_page.overview.title}
            description = {inaugural_season_page.overview.description}
            sizes = {this.props.data.carnegieConcertoImage.sizes}>
          </InfoSection>

          <hr></hr>

          <OverviewBlocks
            blocks = {inaugural_season_page.overview_blocks}
            sizes = {overviewSizes}>
          </OverviewBlocks>

          <hr></hr>

          <FeaturedArtists
            data={inaugural_season_page.featured_artists}
            sizes = {featuredArtistSizes}>
          </FeaturedArtists>

          <hr></hr>

          <ArtistGrid
            data= {inaugural_season_page.teaching_artists}
            sizes = {teachingArtistSizes}
            isShort = {false}>
          </ArtistGrid>

          <hr></hr>

          <InfoSection
            title = {inaugural_season_page.class_of_2017.title}
            description = {inaugural_season_page.class_of_2017.description}
            sizes = {this.props.data.classOf2017Image.sizes}>
          </InfoSection>

          <br></br>
          <br></br>
          <LinkBox data = {inaugural_season_page.link_to_website}></LinkBox>

        </div>
        <Footer></Footer>
      </div>
    );
  }
}

export default InauguralSeasonPage

export const pageQuery = graphql`
  query InauguralSeasonQuery {
    daxunZhangImage: imageSharp(id: { regex: "/daxun_zhang/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    feiXieImage: imageSharp(id: { regex: "/fei_xie/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    frankHuangImage: imageSharp(id: { regex: "/frank_huang/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    gertMortensenImage: imageSharp(id: { regex: "/gert_mortensen/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    guangChenImage: imageSharp(id: { regex: "/guang_chen/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    haiyuWangImage: imageSharp(id: { regex: "/haiyu_wang/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    jayLiuImage: imageSharp(id: { regex: "/jay_liu/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    jieyinWuImage: imageSharp(id: { regex: "/jieyin_wu/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    jindongCaiImage: imageSharp(id: { regex: "/jindong_cai/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    liangWangImage: imageSharp(id: { regex: "/liang_wang/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    qiangTuImage: imageSharp(id: { regex: "/qiang_tu/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    qingLiImage: imageSharp(id: { regex: "/qing_li/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    sibeiWengImage: imageSharp(id: { regex: "/sibei_weng/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes
      }
    },
    weiZhuImage: imageSharp(id: { regex: "/wei_zhu/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    xiaomingHanImage: imageSharp(id: { regex: "/xiaoming_han/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    yaoguangZhaiImage: imageSharp(id: { regex: "/yaoguang_zhai/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    ludovicMorlotImage: imageSharp(id: { regex: "/ludovic_morlot/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    yujaWangImage: imageSharp(id: { regex: "/yuja_wang/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    olgaKernImage: imageSharp(id: { regex: "/olga_kern/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    classOf2017Image: imageSharp(id: { regex: "/class_of_2017/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    carnegieConcertoImage: imageSharp(id: { regex: "/carnegie_concerto/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    jointRehearsalImage: imageSharp(id: { regex: "/joint_rehearsal/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    trainingResidencyImage: imageSharp(id: { regex: "/2017_training_residency/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    concertTourImage: imageSharp(id: { regex: "/2017_concert_tour/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    carnegieDebutImage: imageSharp(id: { regex: "/carnegie_debut/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
  }
`;



// WEBPACK FOOTER //
// ./src/pages/2017-inaugural-season.jsx